export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-29T07:47:12",
  lastPipeline: "6616",
  version: "0.0.0",
  sentryDsn: '',
};
